Date.prototype.isLeapYear = function() {
	var y = this.getFullYear();

	return y % 4 == 0 && y % 100 != 0 || y % 400 == 0;
};


Date.prototype.getDaysInMonth = function() {
	return arguments.callee[this.isLeapYear() ? 'L' : 'R'][this.getMonth()];
};


Date.prototype.getDaysInMonth.R = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
Date.prototype.getDaysInMonth.L = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];


// Дополняет цифры меньше 10 впереди нулем, возвращает строку
function addZero(number) {
	return number < 10 ? '0' + number.toString() : number.toString();
}


// Возвращает номер дня недели от 0(пн) до 6(вс) по входной дате
function getWeekDay(date) { 
	var day = date.getDay();

	if (day == 0) day = 7;
	return day - 1;
}


// Проверяет является ли значение датой
function isValidDate(date) {
	var input = date.match(/\d+/g),
		date = new Date(input[2], input[1] - 1, input[0]);

	return (date.getFullYear() == input[2] && date.getDate() == input[0] && date.getMonth() == input[1] - 1);
}